/**
 * Actionbar control to return to pre-contract intake after opening a design in OneDraw.
 */
import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@phosphor-icons/react';
import { useViewerStore } from '../../store/store';
import {
    clearPreContractReturnFlag,
    hasPreContractReturn,
} from '../lib/preContractLaunch';

function resolveReturnSfid(): string {
    try {
        const fromQuery = new URLSearchParams(window.location.search).get('sfid')?.trim();
        if (fromQuery) return fromQuery;
        return sessionStorage.getItem('SalesForceId')?.trim() ?? '';
    } catch {
        return '';
    }
}

export const PreContractReturnButton: React.FC = () => {
    const navigate = useNavigate();
    const isViewportOnlyEmbed = useViewerStore((s) => Boolean(s.isViewportOnlyEmbed));

    if (isViewportOnlyEmbed || !hasPreContractReturn()) return null;

    const handleBackToPreContract = () => {
        const sfid = resolveReturnSfid();
        clearPreContractReturnFlag();
        const query = sfid ? `?sfid=${encodeURIComponent(sfid)}` : '';
        navigate(`/pre-contract${query}`);
    };

    return (
        <Button
            type="default"
            size="large"
            icon={<ArrowLeftIcon size={22} weight="regular" />}
            onClick={handleBackToPreContract}
        >
            Back to pre-contract
        </Button>
    );
};

export default PreContractReturnButton;
